export default __webpack_public_path__ + "static/media/about-carousel-5-notre-dame.a77690eb.jpg";